package io.jsonize.web.theme

import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateOf

object ThemeState {
    var isDark: MutableState<Boolean> = mutableStateOf(true)
    var initialized: Boolean = false
}
